import { render, staticRenderFns } from "./platform_user_detail.vue?vue&type=template&id=c0315cf0&scoped=true"
import script from "./platform_user_detail.vue?vue&type=script&lang=js"
export * from "./platform_user_detail.vue?vue&type=script&lang=js"
import style0 from "./platform_user_detail.vue?vue&type=style&index=0&id=c0315cf0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0315cf0",
  null
  
)

export default component.exports